(() => {
  const template = document.querySelector('#NathraDeferredComponents');
  if (!template) return;

  const pending = new Map(
    [...template.content.querySelectorAll('script[data-component]')].map((entry) => [
      entry.dataset.component,
      entry.dataset.src,
    ])
  );

  const loadFor = (root) => {
    if (!(root instanceof Element) && root !== document) return;
    for (const [selector, url] of pending) {
      if ((root instanceof Element && root.matches(selector)) || root.querySelector(selector)) {
        pending.delete(selector);
        const script = document.createElement('script');
        script.type = 'module';
        script.src = url;
        script.dataset.nathraComponent = selector;
        document.head.appendChild(script);
      }
    }
  };

  loadFor(document);
  if (!pending.size) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) loadFor(node);
    }
    if (!pending.size) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
